import { Link } from "react-router-dom";
import PageHero from "@/components/PageHero";
import bilousPortrait from "@/assets/bilous.png";
import bilousPortraitWebp from "@/assets/bilous.webp";
import Picture from "@/components/Picture";

const EDUCATION = [
  "Bachelor of Science, Natural Science — University of Texas, Austin",
  "Doctor of Medical Dentistry — Tufts University School of Dental Medicine, Magna Cum Laude, Boston, MA (1996)",
  "Certificate in Orthodontics and Dentofacial Orthopedics — Tufts University School of Dental Medicine, Boston, MA (2001)",
];

const MEMBERSHIPS = [
  "American Association of Orthodontists",
  "American Dental Association",
  "Connecticut State Dental Association — Ethics Committee",
  "Bridgeport Dental Association — Board Member & Treasurer",
  "Omicron Kappa Upsilon National Dental Honor Society",
];

export default function DrBilous() {
  return (
    <>
      <PageHero
        eyebrow="Meet your orthodontist"
        title="Oresta Bilous, DMD"
        intro="Changing smiles — and lives — across generations of families in Fairfield County."
      />

      <section className="bg-cream-50">
        <div className="section grid gap-14 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <div className="relative mx-auto aspect-[4/5] max-w-sm overflow-hidden rounded-[2rem] border border-cream-300/60 bg-sage-100 shadow-soft">
              <Picture
                webp={bilousPortraitWebp}
                src={bilousPortrait}
                alt="Portrait of Dr. Oresta Bilous"
                className="h-full w-full object-cover"
              />
            </div>

            <div className="mt-8 rounded-2xl border border-blush-100 bg-blush-50/60 p-6">
              <h3 className="font-serif text-lg text-sage-800">
                Outside the office
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-sage-700/90">
                Dr. Bilous resides in Easton, CT with her husband Andre and
                their two daughters, Kira and Zoriana. She enjoys cooking,
                yoga, skiing, and spending time with her family. She also
                volunteers every summer as a leader and head counselor at a
                children's camp in upstate New York, and regularly volunteers
                at Special Olympics events.
              </p>
            </div>
          </div>

          <div className="lg:col-span-7 lg:pt-2">
            <p className="eyebrow">Biography</p>
            <h2 className="mt-4 text-3xl sm:text-4xl">
              A lifelong passion for creating beautiful smiles — and genuine
              connections.
            </h2>

            <div className="mt-6 space-y-5 text-sage-700/90">
              <p>
                Dr. Bilous grew up in upstate New York and has had the
                opportunity to live across the country — in Virginia, Texas,
                Connecticut, Illinois, and Massachusetts — before putting down
                roots in Fairfield County. She attended the University of
                Texas at Austin for her undergraduate degree, then went on to
                Tufts University School of Dental Medicine in Boston, where
                she earned her DMD{" "}
                <em>Magna Cum Laude</em> in 1996.
              </p>
              <p>
                After graduation she spent three years practicing general
                dentistry in Chicago, where she also met and married her
                husband Andre. She then returned to Boston to complete her
                Orthodontic Residency at Tufts, earning her specialty
                Certificate in Orthodontics and Dentofacial Orthopedics
                in 2001.
              </p>
              <p>
                Dr. Bilous believes that being an orthodontist is a privilege
                and an incredibly rewarding calling. She feels fortunate to
                treat generations of families and watch her younger patients
                grow up to be amazing adults. She regularly attends continuing
                education seminars, state and local dental society meetings,
                and yearly orthodontic conventions to stay current on the
                latest techniques and research.
              </p>
            </div>

            <div className="mt-10 grid gap-6 sm:grid-cols-2">
              <div className="rounded-2xl border border-sage-100 bg-cream-100/60 p-6">
                <h3 className="font-serif text-lg text-sage-800">Education</h3>
                <ul className="mt-3 space-y-2 text-sm leading-relaxed text-sage-700/90">
                  {EDUCATION.map((item) => (
                    <li key={item} className="flex gap-2">
                      <span aria-hidden="true" className="text-blush-400">
                        •
                      </span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="rounded-2xl border border-sage-100 bg-cream-100/60 p-6">
                <h3 className="font-serif text-lg text-sage-800">
                  Professional memberships
                </h3>
                <ul className="mt-3 space-y-2 text-sm leading-relaxed text-sage-700/90">
                  {MEMBERSHIPS.map((item) => (
                    <li key={item} className="flex gap-2">
                      <span aria-hidden="true" className="text-blush-400">
                        •
                      </span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <Link to="/#contact" className="btn-primary">
                Request an appointment
              </Link>
              <Link to="/" className="btn-secondary">
                Back to home
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
